import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

export default function SimpleModal({open = false, classes= {}, onCloseModal, children}) {

    return (
        <div>
            <Modal
                open={open}
                onClose={onCloseModal}
                center
                classNames={{root: "pol-simple-modal", ...classes}}
                closeIcon={<i className="icon-thin-times text-white text-xl" />}
                blockScroll
            >
                {children}
            </Modal>
        </div>
    )
}
